export class GetSections {
    static readonly type = '[Marketing] GetSections';
}
